import Container = Phaser.GameObjects.Container;
import { GameService } from './gameService';
import { injectable, IocContext } from 'power-di';

@injectable()
export class AnimationService {
    private scene: Phaser.Scene;

    public setScene(scene: Phaser.Scene) {
        this.scene = scene;
    }
}
